<template>
  <div class="content">
    <p class="ttile">
      优惠券<span>(说明:用户能在当前页面直接领取，今领取后券变为灰色。)</span>
    </p>
    <div class="set-content ">
      <div class="set-item" style="margin-bottom: 30px;">
        <p class="title">选择类型</p>
        <TypeGroup
          v-if="haveTypeField"
          v-model="curComponent.type"
          :options="typeOptions"
        />
      </div>
      <div class="set-item add-coupon">
        <p class="title">添加优惠券</p>
        <p class="dec">最多可添加20张优惠券</p>

        <el-table :data="curComponent.coupons" border style="width: 100%">
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column prop="id" label="ID"> </el-table-column>
          <el-table-column prop="couponCategory" label="类型">
            <template slot-scope="scope">
              <p>{{ scope.row.couponCategory | couponCategoryText }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="面额门槛（元）">
            <template slot-scope="scope">
              <div v-if="scope.row.lessAmount">
                {{ scope.row.lessAmount }}/{{ scope.row.fullAmount }}
              </div>
            </template></el-table-column
          >
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="color:#2154f4"
                @click="deleteCouponItem(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-button
          class="select-btn"
          icon="el-icon-plus"
          @click="couponListDialog = true"
          >选择优惠券（{{ curComponent.coupons.length }}/{{
            maxCount
          }}）</el-button
        >

        <!-- <div class="select-view">
          <span>排列样式</span>
          <span>横向滑动</span>
        </div> -->
      </div>

      <div class="set-item basic-set">
        <p class="title">样式基础设置</p>
        <SpPickerColor
          v-model="curComponent.styleBasicSet.backgroundColor"
          :isGradient="true"
          label="背景颜色"
        />
        <!-- <SpPickerColor
          v-model="curComponent.styleBasicSet.selectedColor"
          label="选中-背景颜色"
        /> -->
        <!-- <SpPickerColor
          v-model="curComponent.styleBasicSet.textColor"
          label="文字颜色"
        /> -->
        <SpSlider
          v-if="havePageMxField"
          v-model="curComponent.styleBasicSet.pageMx"
          label="页面间距"
        />
        <SpSlider
          v-if="haveLineMarginField"
          v-model="curComponent.styleBasicSet.lineMargin"
          label="行间距"
        />
        <SpSlider
          v-if="havePageMbField"
          v-model="curComponent.styleBasicSet.pageMb"
          label="页面底部间距"
        />
      </div>
    </div>

    <SelectCouponDialog
      :couponListDialog="couponListDialog"
      @closecCouponListDialog="val => (couponListDialog = val)"
      @couponListSelect="couponListSelect"
      :SelectedCouponList="curComponent.coupons"
      :canMultipleChoice="true"
      :maxCount="maxCount"
    />
  </div>
</template>

<script>
import TypeGroup from "./components/TypeGroup";
import typeOptions from "./typeOptions";

import SpSlider from "../../../components/SpSlider";
import SpPickerColor from "../../../components/SpPickerColor";
import SelectCouponDialog from "../../../components/SelectCouponDialog";
export default {
  components: {
    SpSlider,
    TypeGroup,
    SpPickerColor,
    SelectCouponDialog
  },
  inject: ["control"],
  computed: {
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent.coupons = val;
      }
    },
    // v1.2.1新增 start
    haveTypeField() {
      const flag = "type" in this.curComponent;
      if (!flag) {
        this.$set(this.control.curComponent, "type", "CouponSlider");
      }
      return "type" in this.curComponent;
    },
    havePageMxField() {
      const flag = "pageMx" in this.curComponent.styleBasicSet;
      if (!flag) {
        this.$set(this.control.curComponent.styleBasicSet, "pageMx", 10);
      }
      return "pageMx" in this.curComponent.styleBasicSet;
    },
    havePageMbField() {
      const flag = "pageMb" in this.curComponent.styleBasicSet;
      if (!flag) {
        this.$set(this.control.curComponent.styleBasicSet, "pageMb", 0);
      }
      return "pageMb" in this.curComponent.styleBasicSet;
    },
    haveLineMarginField() {
      const flag = "lineMargin" in this.curComponent.styleBasicSet;
      if (!flag) {
        this.$set(this.control.curComponent.styleBasicSet, "lineMargin", 5);
      }
      return "lineMargin" in this.curComponent.styleBasicSet;
    }
    // end
  },
  filters: {
    couponCategoryText(val) {
      return {
        0: "全场券",
        1: "商品券",
        2: "运费券"
      }[val];
    }
  },
  data() {
    return {
      typeOptions: Object.freeze(typeOptions),
      maxCount: 20,
      couponListDialog: false
    };
  },
  methods: {
    deleteCouponItem(row) {
      const { coupons } = this.curComponent;
      const index = coupons.findIndex(item => item.id === row.id);
      this.curComponent.coupons.splice(index, 1);
    },
    couponListSelect(params) {
      this.curComponent.coupons = params.map(item => {
        const receiveStartTime = item.receiveEndTime
          .split(" ")[0]
          .replace("-", ".");
        const receiveEndTime = item.receiveEndTime
          .split(" ")[0]
          .replace(/-/g, ".");
        const {
          id,
          name,
          lessAmount,
          fullAmount,
          userType,
          allProductFlag,
          couponCategory
        } = item;
        return {
          id,
          name,
          lessAmount,
          userType,
          fullAmount,
          allProductFlag,
          receiveStartTime,
          receiveEndTime,
          couponCategory,
          receiveStatus: 0
        };
      });
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      padding-left: 10px;
    }
  }
  > .set-content {
    padding-top: 15px;
    padding: 20px 24px;
    > .set-item {
      > .title {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 12px;
      }
      > .dec {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-bottom: 20px;
      }
      > .select-view {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 12px;
        > span {
          font-size: 12px;
          font-weight: 400;
        }
        > span:first-child {
          color: #999999;
        }
        > span:last-child {
          color: #333333;
          padding-left: 10px;
        }
      }
    }
    > .basic-set {
      margin-top: 30px;
      /deep/ .picker-color,
      .slider-content {
        margin-bottom: 20px;
      }
    }
    > .add-coupon {
      /deep/ .el-table {
        th {
          background: #f5f5f5;
          padding: 0;
          height: 32px;
          line-height: 32px;
        }
        td {
          padding: 0;
          height: 41px;
          line-height: 41px;
        }
        .cell {
          padding: 0 10px;
          text-align: center;
        }
      }
      /deep/ .select-btn {
        width: 332px;
        height: 30px;
        background: #ffffff;
        border-radius: 2px;
        border: 1px solid #2154f4;
        color: #2154f4;
        font-size: 12px;
        padding: 0;
        margin-top: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/marketingComponents/Coupon/Attr.vue